module.exports = __webpack_public_path__ + "img/newO.ec57f9ef.png";